import apiClient from './api';

// Experience stories: details a resume leaves out (results, numbers), saved from
// the questions before a letter and from the cover letter chat. Every later
// letter uses the ones that fit the job.
export default {
  async list() {
    const response = await apiClient.get('/jobseeker/experience-stories/');
    return response.data.stories || [];
  },

  async save({ question = '', answer = '', experienceId = null, skills = [], source = 'interview' }) {
    const response = await apiClient.post('/jobseeker/experience-stories/', {
      question,
      answer,
      experience_id: experienceId,
      skills,
      source,
    });
    return response.data;
  },

  async update(id, answer) {
    const response = await apiClient.patch(`/jobseeker/experience-stories/${id}/`, { answer });
    return response.data;
  },

  async remove(id) {
    await apiClient.delete(`/jobseeker/experience-stories/${id}/`);
  },
};
